import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Crime,
  GeneralType,
  GovernyInfo,
  ThiefActionType
} from "../../../../lib/types";
import { GENERAL_TYPE } from "../../../../lib/enums";
import Counterintelligence from "./Counterintellingence";
import SubMenu from "../../../Menu/SubMenu";
import CrimesSection from "./CrimesSection";

const mapStateToProps = (state: any) => ({
  govId: state.governorate.id,
  gold: state.governorate.resources.gold,
  crimes: state.governorate.crimes,
  crimeTypes: state.governorate.crimeTypes,
  limitingCrimes: state.governorate.limitingCrimes,
  crimesLimit: state.governorate.crimesLimit,
  alliance: state.governorate.alliance,
  opponent: state.governorate.opponent,
  readyToThieves: state.governorate.readyToThieves,
  canSendCounterintelligence: state.governorate.canSendCounterintelligence,
  thiefGeneral: state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.THIEF).general
})

const connector = connect(mapStateToProps);

const Thieves = ({
  govId,
  gold,
  crimes,
  crimeTypes,
  limitingCrimes,
  crimesLimit,
  alliance,
  opponent,
  readyToThieves,
  canSendCounterintelligence,
  thiefGeneral
}: ConnectedProps<typeof connector>) => (
  <>
      <SubMenu
        tabs={[
          {
            name: "Thieves",
            title: "Thieves",
            icon: "zlodeji",
            label: "Crimes",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "ThievesEmperorTent",
            title: "Thieves",
            icon: "zlodeji",
            label: "Emperor Tent",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />
      <section className="boxes-group">
        <div className="box text-info">
          <p className="js-attacks-summary">
            {readyToThieves
              ? <>
                {crimes.length
                  ? <>You sent <em>{crimes.length}</em> crimes</>
                  : <>You didn't send any crimes</>
                }
                <br />Crimes limit&nbsp;<em>{limitingCrimes}</em>/<em>{crimesLimit}</em>
              </>
              : <span className="negative">Thievish actions and crimes are not available until 8th turn and out of war.{!thiefGeneral ? " You need thief general for orchestration of your thieves." : ""}</span>
            }
          </p>
        </div>
        <span className="divider"/>
        <h2 className="h2 h2-first">
          <span className="bordered">Crimes</span>
        </h2>
        <span className="divider"/>
        <CrimesSection
          sender={govId}
          gold={gold}
          readyToThieves={readyToThieves}
          crimeTypes={crimeTypes.filter((crime: ThiefActionType) => crime.id !== 8)}
          limitingCrimes={limitingCrimes}
          crimesLimit={crimesLimit}
          crimes={crimes}
          opponent={opponent}
        />
        <span className="divider"/>
        <span className="divider"/>
        <h2 className="h2 h2-first">
          <span className="bordered">Counterintelligence</span>
        </h2>
        <span className="divider"/>
        <div className="box">
          <p className="text-info text-center js-message-wrap">{(limitingCrimes >= crimesLimit && !canSendCounterintelligence) ? "Governorate has reached crimes limit" : ""}</p>
          <table className="table vertical-top">
            <thead>
            <tr>
              <th className="text-left">Governorate</th>
              <th className="text-left">State</th>
            </tr>
            </thead>
            <tbody>
            {
              alliance?.members.filter((member: GovernyInfo) => member.id !== govId)
                .map((member: GovernyInfo) => <Counterintelligence
                  sender={govId}
                  gold={gold}
                  target={member}
                  disabled={!readyToThieves
                  || (limitingCrimes >= crimesLimit && !canSendCounterintelligence)}
                  counterintelligence={crimes.find((crime: Crime) => crime.target.id === member.id)}
                  counterintelligenceType={crimeTypes
                    .find((crime: ThiefActionType) => crime.id === 8)}
                />)
            }
            </tbody>
          </table>
        </div>
        <span className="divider"/>
        <div className="box">

        </div>
        <span className="divider"/>
      </section>
  </>
)

export default connector(Thieves);
